// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__kqqOC","header":"Section_header__3XWL4","flagsContainer":"Section_flagsContainer__vOoV0"};